import { ActionsTableModule } from 'projects/access-control/src/app/UI/commons/actions-table/actions-table.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TabsComponent } from './tabs/tabs.component';
import { PaginationComponent } from './pagination/pagination.component';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { DropdownModule } from 'primeng/dropdown';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipesModule } from 'projects/access-control/src/app/Infrastructure/pipes/pipes.module';
import { EditorModule } from 'primeng/editor';
import { SubSidebarModule } from './sub-sidebar/sub-sidebar.module';
import { PasswordModule } from 'primeng/password';
import { MultiSelectModule } from 'primeng/multiselect';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputPasswordComponent } from './input-password/input-password.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { loadingSpinnerModule } from './loading-spinner/loading-spinner.module';
import { PopoverStatusComponent } from './popover-status/popover-status.component';
import { DirectivesModule } from 'projects/access-control/src/app/Infrastructure/directive/directives.module';
import { TooltipModule } from 'primeng/tooltip';
import { FilterComponent } from './filter/filter.component';
import { MatChipsModule } from '@angular/material/chips';
import { DropdownStatusComponent } from './dropdown-status/dropdown-status.component';
import { S3UploadModule } from '@mangosoft/mango-layout';

@NgModule({
	declarations: [
		TabsComponent,
		PaginationComponent,
		InputPasswordComponent,
		PopoverStatusComponent,
		FilterComponent,
		DropdownStatusComponent,
	],
	exports: [
		TabsComponent,
		PaginationComponent,
		InputPasswordComponent,
		PopoverStatusComponent,
		FilterComponent,
		FormsModule,
		ReactiveFormsModule,
		DropdownStatusComponent,
	],
	imports: [
		MultiSelectModule,
		MatChipsModule,
		CommonModule,
		MatIconModule,
		ReactiveFormsModule,
		S3UploadModule,
		MatSelectModule,
		// CodeEditorModule,
		PipesModule,
		InputSwitchModule,
		FormsModule,
		PasswordModule,
		NgxDatatableModule,
		loadingSpinnerModule,
		ActionsTableModule,
		TooltipModule,
		MenuModule,
		DropdownModule,
		InfiniteScrollModule,
		EditorModule,
		DirectivesModule,
		SubSidebarModule,
		DragDropModule,
	],
	providers: [],
})
export class CommonsModule {}
